import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { first, from, map } from 'rxjs';
import { AuthService } from '../auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);

  // Check the authentication status
  const auth = inject(AuthService).auth();

  return from(auth.authStateReady()).pipe(
    first(),
    map(() => {
      // If the user is not authenticated...
      if (auth.currentUser === null) {
        // Redirect to the sign-in page with a redirectURL param
        const redirectURL =
          state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;

        return router.parseUrl(`sign-in?${redirectURL}`);
      }

      // Allow the access
      return true;
    }),
  );
};
